import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TipoDocumento } from 'src/app/pages/configuracion/Envios/documentos/models/tipo-documento';
import { LoginService } from 'src/app/pages/login/services/login.service';
import { ConversionDatosApiService } from 'src/app/shared/services/conversion-datos-api.service';
import { EndpointService } from 'src/app/shared/services/endpoint.service';
import { IRecuperarTiposDocumentoService } from './ports/i-recuperar-tipos-documento-service';
import { normalizarDocumentoEntradaApi } from './documento-entrada-api-normalizer';
import { OrdenColumna } from 'src/app/shared/models/orden-columna';
import { FiltroSqp } from 'src/app/shared/components/sqp-components/sqpFiltroSuperior/models/filtro-sqp';

@Injectable({
  providedIn: 'root'
})

export class RecuperaTipoDocumentoApiService implements IRecuperarTiposDocumentoService{

  private readonly URL_GET_TIPO_DOCUMENTO: string = this.endpointService.UrlGetTipoDocumento;
  private URL_ALTA_TIPO_DOCUMENTO: string = this.endpointService.UrlAltaTipoDocumento;

  documentos: any[];

  constructor(private client: HttpClient,
              private loginService: LoginService,
              private endpointService: EndpointService,
              private conversionDatosApiService: ConversionDatosApiService) { }


    getTipoDocumentos(filtrosSqp: FiltroSqp[], pageNumber:number, pageSize:number = 500, orden: OrdenColumna = {campoOrden:'', orden:''}): Observable<TipoDocumento[]>{
      let pageSizeParam:number = pageNumber==0 ? 0 : 500;
      let pageNumberParam:number = pageNumber==0 ? 0 : pageNumber;
      let tipoDoc = filtrosSqp.find(x=>x.titulo=='Tipo documento')?.valoresSeleccionados?.valorString;
      let filtroBuscar = filtrosSqp.find(x=>x.titulo=='Buscar')?.valoresSeleccionados?.valorString;

      let params = new HttpParams()
        .set('pageNumber', pageNumberParam)
        .set('pageSize', pageSizeParam)
        .set('filtroBuscar', filtroBuscar ? filtroBuscar : '')

      // Añadimos el filtro GENERICO basado en tipoDoc
      if (tipoDoc === 'Plantilla') {
        params = params.set('filtros[GENERICO]', 'true');
      } else if (tipoDoc === 'Doc con datos personales') {
        params = params.set('filtros[GENERICO]', 'false');
      }
      // Si tipoDoc es 'TODOS' o cualquier otro valor, no añadimos el filtro

      const options = {
        headers: new HttpHeaders({
          'Content-Type':'application/json',
          'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token
        }),
        params: params
      };
      if(orden.campoOrden &&orden.campoOrden == 'tipoDoc'){
        params = params.set('orden[GENERICO]', orden.orden);
      }else if (orden.campoOrden) {
        options.params = options.params.set(`orden[${orden.campoOrden.toUpperCase()}]`, orden.orden);
      }
      return this.client.get(this.URL_GET_TIPO_DOCUMENTO, options).pipe(
        map((response: any) =>{
          if (response) {
            this.documentos = this.conversionDatosApiService.mapDocumentosEntrada(response)
            this.documentos.forEach(doc => normalizarDocumentoEntradaApi(doc));
            return this.documentos;
          }
          else throw new Error(response);
        })
      );

  }


  guardaDocumento(data:any): Observable<any> {
    data.activo = true;
    data = this.conversionDatosApiService.mapDocumentosSalida(data);
    if(data.FirmantesNif.length>0){
      data.FirmantesNif = this.conversionDatosApiService.mapFirmantesNifSalida(data.FirmantesNif);
    }
    data.TiposContenido = this.conversionDatosApiService.mapTiposContenidoSalida(data.TiposContenido);

    const options = {
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token
      })
    };
    return this.client.post<any>(this.URL_ALTA_TIPO_DOCUMENTO, data, options)
  }
}
